import styled from "styled-components";

export const CompleteFilter = styled.section`
    display: flex;
    flex-direction: row;
    margin-top: 1em;
    margin-bottom: 1em;
    margin-left: 4.5em;
`

export const Filterpart = styled.div`
    width: max-content;
    display: inline-block;
    position: relative;
    width: 20em;

    &:hover {
        display: block;
    }
`

export const FilterList = styled.ul`
    margin-top: 0;
    margin-bottom: 1em;
    padding: 0;
    height: 6em;
    overflow: hidden; 
    overflow-y: scroll;
    box-shadow: 0 0 4px 2px rgba(0, 139, 139, 0.5);
    width: 100%;

    position: absolute;
    left: 0; top: 100%;
    width:100%;
    background-color: whitesmoke;
`

export const FilterInput = styled.input`
    text-align: center;
    width: 100%;

    &:focus {
        outline:none;
        box-shadow: 0 0 4px 2px rgba(0, 139, 139, 0.5);
    }
`

export const FilterAuswahlButton = styled.button`
    margin-left: 2em;
    margin-top: 0.2em;
    padding: 0.2em 0.5em;
`

export const FilterDates = styled.div`
    width: fit-content;
    margin-top: 1em;
    margin-bottom: 1em;
    margin-left: 4.5em;
`

export const FilterDatesInput = styled.input`
    margin-left: 1em;
    margin-right: 1em;
`

export const FilterAction = styled.button`
    margin-left: 5.5em;
    margin-bottom: 1em;
`